const uiText = {
    zhHans: {
      generate: "我今天真的不想上班",
      copy: "复制这个理由",
      toast: "你已准备好不来上班!"
    },
    zhHant: {
      generate: "我今天真的不想上班",
      copy: "複製這個理由",
      toast: "你已經做好不出現的心理準備了。"
    },
    en: {
      generate: "I really tired and don't want work today",
      copy: "Copy this excuse",
      toast: "You are now fully prepared to not show up."
    },
    ms: {
      generate: "Saya betul-betul penat dan tak nak kerja hari ini",
      copy: "Salin alasan ini",
      toast: "Anda sudah bersedia untuk tidak hadir kerja."
    }
  };
  export default uiText;